import React, { useEffect, useState } from 'react'
import DifficultyChart from './DifficultyChart'

function AdaptiveEvalutionGraph({ studentMarksDetails, setOpenGraphPopup, chartData, studentResultData }) {
    const studentData = JSON.parse(localStorage.getItem("breathForStudent"))
    const chartDatas = {
        labels: chartData?.map((item) => item.questionNumber),
        values: studentResultData.difficulty_history?.map((item) => item.ability),
        isCorrect: studentResultData.difficulty_history?.map((item) => item.isCorrect),
        data: studentResultData?.results.map((item) => item.question_response)
    };

    const [scores, setScores] = useState({
        VE: { correct: 0, wrong: 0 },
        E: { correct: 0, wrong: 0 },
        M: { correct: 0, wrong: 0 },
        H: { correct: 0, wrong: 0 },
        VH: { correct: 0, wrong: 0 },
    });

    useEffect(() => {
        function populateCorrectWrongCount() {
            let updatedScores = {
                VE: { correct: 0, wrong: 0 },
                E: { correct: 0, wrong: 0 },
                M: { correct: 0, wrong: 0 },
                H: { correct: 0, wrong: 0 },
                VH: { correct: 0, wrong: 0 },
            };

            studentResultData.difficulty_history.forEach((item) => {
                let difficulty = item.difficulty;
                let isCorrect = item.isCorrect;

                switch (difficulty) {
                    case 1:
                        updatedScores.VE.correct += isCorrect ? 1 : 0;
                        updatedScores.VE.wrong += !isCorrect ? 1 : 0;
                        break;
                    case 2:
                        updatedScores.E.correct += isCorrect ? 1 : 0;
                        updatedScores.E.wrong += !isCorrect ? 1 : 0;
                        break;
                    case 3:
                        updatedScores.M.correct += isCorrect ? 1 : 0;
                        updatedScores.M.wrong += !isCorrect ? 1 : 0;
                        break;
                    case 4:
                        updatedScores.H.correct += isCorrect ? 1 : 0;
                        updatedScores.H.wrong += !isCorrect ? 1 : 0;
                        break;
                    case 5:
                        updatedScores.VH.correct += isCorrect ? 1 : 0;
                        updatedScores.VH.wrong += !isCorrect ? 1 : 0;
                        break;
                    default:
                        break;
                }

            })

            setScores(updatedScores);
        }
        populateCorrectWrongCount();
    }, [studentResultData]); // Re-run when `unitAssessmentModelArrayList` changes

    const data = [
        {
            level: "Very Easy",
            correct: scores.VE.correct,
            incorrect: scores.VE.wrong,
        },
        { level: "Easy", correct: scores.E.correct, incorrect: scores.E.wrong },
        { level: "Medium", correct: scores.M.correct, incorrect: scores.M.wrong },
        { level: "Hard", correct: scores.H.correct, incorrect: scores.H.wrong },
        {
            level: "Very Hard",
            correct: scores.VH.correct,
            incorrect: scores.VH.wrong,
        },
    ];


    return (
        <div className="successful_create_transprant_body">
            <img
                src="/images/cross-circle3.svg"
                className=""
                style={{ position: "absolute", top: "10px", right: "11%" }}
                alt=""
                onClick={(e) => setOpenGraphPopup(false)}
            />
            <div className=" p-2 successful_create_container shadow" style={{ width: "73%", height: "90%", position: "relative" }}>
                <div
                    className="student-data"
                    style={{
                        position: "absolute",
                        top: "2px",
                        left: "1%",
                        backgroundColor: "transparent",
                    }}
                >
                    {`${studentData?.name} | ${studentData?.standard?.name}-${studentData?.section?.name} | ${studentResultData?.assessment?.name}`}
                </div>
                <div className="my-2 successfully_create_message">
                    {/* <img src='/images/no-image5.png' alt='img' /> */}
                    <DifficultyChart data={chartDatas} />
                </div>
                <div className="d-flex justify-content-around w-full">
                    <div className="leftText">
                        <div className="d-flex justify-content-between">
                            <div className="leftText1"><span className="score">Score:</span></div>
                            <div className="score">{studentResultData?.ability?.toFixed(2)}</div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div className="leftText1">Total Attempted Questions:</div>
                            <div className="score">{studentMarksDetails?.attempted_questions?.toString().padStart(2, "0")}</div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div className="correctans">Correct Answers: </div>
                            <div className="correctans">{(Number(studentResultData?.correct_count))?.toString().padStart(2, "0")}</div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div className="wrongans">Wrong Answers:</div>
                            <div className="wrongans"> {studentResultData?.incorrect_count === 0
                                ? studentResultData?.incorrect_count
                                : studentResultData?.incorrect_count
                                    ?.toString()
                                    ?.padStart(2, "0")}</div>
                        </div>

                    </div>
                    <div className="rightText">
                        <table className="difficulty-table">
                            <thead>
                                <tr style={{ textAlign: "center" }}>
                                    <th style={{ color: "#800080" }}>Difficulty Level</th>
                                    <th style={{ color: "#00b050" }}>Correct</th>
                                    <th style={{ color: "#c00000" }}>Incorrect</th>
                                </tr>
                            </thead>
                            <tbody style={{ textAlign: "center" }}>
                                {data.map((row, index) => (
                                    <tr key={index}>
                                        <td className="rightText1">{row.level}</td>
                                        <td className="correctans">{row.correct}</td>
                                        <td className="wrongans">{row.incorrect}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {/* <button onClick={() => setRecordAnswer(!recordAnswer)}></button> */}
                </div>
            </div>
        </div>
    )
}

export default AdaptiveEvalutionGraph